import Vue from "vue";
import Router from "vue-router";
import Login from "components/login/login";
import Home from "components/home/home";
import User from "components/user/user";
import Supplier from "components/supplier/supplier";
import AddSupplier from "components/supplier/addSupplier";
import Raise from "components/raise/raise";
import Product from "components/product/product";
import AddProduct from "components/product/addProduct";
import Category from "components/product/category";
import StoreProduct from "components/product/storeProduct";
import DirectSell from "components/product/directSell";
import NewOrder from "components/order/newOrder";
import Order from "components/order/order";
import Orders from "components/order/orders";
import GroupOrders from "components/order/groupOrders";
import JdOrder from "components/order/jdOrder";
import GoodUnit from "components/order/goodUnit";
import Balance from "components/balance/balance";
import Permission from "components/permission/permission";
import System from "components/system/system";
import ProductArea from "components/system/productArea";
import StoreAudit from "components/store/pageAudit";
import StoreList from "components/store/pageList"; // 门店列表
import TeacheList from "components/teache/teacherList"; //技师列表
import StoreCategory from "components/store/pageCategory"; // 门店分类
import TeacheCategory from "components/teache/teacherCategory"; // 技师分类
import StoreAdd from "components/store/pageAdd"; //添加门店
import TeacheAdd from "components/teache/teacherAdd"; // 添加技师
import Delivery from "components/store/delivery";
import FStore from "components/finance/store";
import FCoupon from "components/finance/coupon";
import FAccountChange from "components/finance/accountChange";
import ConsumptionRecord from "components/finance/consumptionRecord";
import BusinessSubsidiesRecord from "components/finance/businessSubsidiesRecord";
import UserWithdraw from "components/finance/userWithdraw";
import StoreOrderQuick from "components/storeOrder/pageQuick";
import StoreOrderPick from "components/storeOrder/pagePick";
import PagePsPick from "components/storeOrder/pagePsPick";
import Bonus from "components/finance/bonus";
import AppManage from "components/system/appManage";

import StoreStockOrder from "components/order/storeStockOrder";
import HomeOrder from "components/order/homeOrder";
import QtManage from "components/system/qtManage";
import IndexManage from "components/system/indexManage";
import IndexPinpai from "components/system/indexPinpai";
Vue.use(Router);

export default new Router({
  linkActiveClass: "layui-this",
  routes: [
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/user",
      name: "user",
      component: User
    },
    {
      path: "/supplier",
      name: "supplier",
      component: Supplier
    },
    {
      path: "/goodUnit",
      name: "goodUnit",
      component: GoodUnit
    },
    {
      path: "/addSupplier",
      name: "addSupplier",
      component: AddSupplier
    },
    {
      path: "/raise",
      name: "raise",
      component: Raise
    },
    {
      path: "/product",
      name: "product",
      component: Product
    },
    {
      path: "/addProduct",
      name: "addProduct",
      component: AddProduct
    },
    {
      path: "/category",
      name: "category",
      component: Category
    },
    {
      path: "/storeProduct",
      name: "storeProduct",
      component: StoreProduct
    },
    {
      path: "/directSell",
      name: "directSell",
      component: DirectSell
    },
    {
      path: "/newOrder",
      name: "newOrder",
      component: NewOrder
    },
    {
      path: "/order",
      name: "order",
      component: Order
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders
    },
    {
      path: "/groupOrders",
      name: "groupOrders",
      component: GroupOrders
    },
    {
      path: "/jdOrder",
      name: "jdOrder",
      component: JdOrder
    },
    {
      path: "/balance",
      name: "balance",
      component: Balance
    },
    {
      path: "/permission",
      name: "permission",
      component: Permission
    },
    {
      path: "/system",
      name: "system",
      component: System
    },
    {
      path: "/productArea",
      name: "productArea",
      component: ProductArea
    },
    // 门店审核
    {
      path: "/store/audit",
      name: "storeAudit",
      component: StoreAudit
    },
    // 门店列表
    {
      path: "/store/list",
      name: "storeList",
      component: StoreList
    },
    // 门店分类
    {
      path: "/store/category",
      name: "storeCategory",
      component: StoreCategory
    },
    // 添加门店
    {
      path: "/store/add",
      name: "storeAdd",
      component: StoreAdd
    },
    // 技师分类
    {
      path: "/teache/category",
      name: "teacheCategory",
      component: TeacheCategory
    },
    // 技师列表
    {
      path: "/teache/list",
      name: "teacheList",
      component: TeacheList
    },
    // 添加技师
    {
      path: "/teache/add",
      name: "teacheAdd",
      component: TeacheAdd
    },
    // 配送
    {
      path: "/store/delivery",
      name: "delivery",
      component: Delivery
    },
    // 财务统计---门店提现
    {
      path: "/finance/store",
      name: "financeStore",
      component: FStore
    },
    {
      path: "/finance/coupon",
      name: "financeCoupon",
      component: FCoupon
    },
    {
      path: "/finance/accountChange",
      name: "financeAccountChange",
      component: FAccountChange
    },
    {
      path: "/finance/consumptionRecord",
      name: "consumptionRecord",
      component: ConsumptionRecord
    },
    {
      path: "/finance/businessSubsidiesRecord",
      name: "businessSubsidiesRecord",
      component: BusinessSubsidiesRecord
    },
    {
      path: "/finance/userWithdraw",
      name: "userWithdraw",
      component: UserWithdraw
    },
    // 门店订单---快捷买单
    {
      path: "/store/order/quick",
      name: "storeOrderQuick",
      component: StoreOrderQuick
    },
    // 门店订单---自提订单
    {
      path: "/store/order/pick",
      name: "storeOrderPick",
      component: StoreOrderPick
    },
    // 门店订单---自提订单
    {
      path: "/storeOrder/PagePsPick",
      name: "pagePsPick",
      component: PagePsPick
    },
    // 财务统计-红利统计
    {
      path: "/finance/bonus",
      name: "bonus",
      component: Bonus
    }, // APP管理
    {
      path: "/appManage",
      name: "appManage",
      component: AppManage
    },
    {
      path: "/storeStockOrder",
      name: "storeStockOrder",
      component: StoreStockOrder
    },
    {
      path: "/homeOrder",
      name: "homeOrder",
      component: HomeOrder
    },
    {
      path: "/qtManage",
      name: "qtManage",
      component: QtManage
    },
    {
      path: "/indexManage",
      name: "indexManage",
      component: IndexManage
    },
    {
      path: "/indexPinpai",
      name: "indexPinpai",
      component: IndexPinpai
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js